import { render, staticRenderFns } from "./FullScreenAccordion.vue?vue&type=template&id=1ab84d30&scoped=true"
import script from "./FullScreenAccordion.vue?vue&type=script&lang=js"
export * from "./FullScreenAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab84d30",
  null
  
)

export default component.exports